// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')

const bem = BemEntity('Button')

function Button(props) {
  const {
    className,
    children,
    title,
    onClick
  } = props
  const {
    tagName,
    disabled,
    href,
    target,
    type
  } = derivedButtonProps(props)
  return React.createElement(tagName, {
    className: classNames(
      className,
      bem.block({ disabled })
    ),
    disabled,
    href,
    target,
    title,
    type,
    onClick
  },
    children
  )
}

Button.propTypes = {
  // Values
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  target: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  // Callbacks
  onClick: PropTypes.func
}

Button.withButton = className => {
  const highOrderComponent = props => {
    return React.createElement(Button, {
      ...props,
      className: classNames(className, props.className)
    })
  }
  highOrderComponent.displayName = `withButton(${className})`
  highOrderComponent.propTypes = Button.propTypes
  return highOrderComponent
}

module.exports = Button

function derivedButtonProps(props) {
  if (props.href && !props.disabled) {
    return {
      tagName: 'a',
      href: props.href,
      target: props.target
    }
  }
  return {
    tagName: 'button',
    type: props.type || 'button',
    disabled: !!props.disabled
  }
}
